import React from "react";
import { connect } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";

import AuditHistory from "../../components/audit/AuditHistory";
import AuditPageShell, {
  AuditInvalidLinkMessage,
} from "../../components/audit/AuditPageShell";
import { getAuditEntityConfig } from "../../components/audit/auditEntityConfig";
import EmptyModal from "../../components/modals/EmptyModal";
import { withRouter } from "../../shared/utility";
import * as actions from "../../store/actions/index";
import { useAuditHistoryLoader } from "../../viewmodels/audit/useAuditHistoryLoader";
import { useAuditHistoryViewModel } from "../../viewmodels/audit/useAuditHistoryViewModel";

function AuditPage({ logout, addSnackbar, mode }) {
  const { entityType: slug, entityId } = useParams();
  const [searchParams] = useSearchParams();
  const entityName = searchParams.get("name");
  const entityConfig = getAuditEntityConfig(slug);
  const apiEntityType = entityConfig?.entityType;

  const auditVm = useAuditHistoryViewModel(
    logout,
    mode === "entity" ? entityId : null,
    apiEntityType,
    addSnackbar,
  );
  const { emptyModal, setEmptyModelOpen } = auditVm;

  const canLoad =
    Boolean(apiEntityType) &&
    (mode === "entityType" || Boolean(entityId));

  useAuditHistoryLoader(auditVm, canLoad);

  if (!apiEntityType || (mode === "entity" && !entityId)) {
    return <AuditInvalidLinkMessage />;
  }

  const typeLabel = entityConfig.label;
  const isEntityMode = mode === "entity";
  const displayName = entityName?.trim() || `#${entityId}`;
  const title = isEntityMode ? "Audit history" : "Audit histories";
  const description = isEntityMode
    ? `${typeLabel}: ${displayName} — changes recorded on create, update, and delete.`
    : `All ${typeLabel.toLowerCase()} changes — create, update, and delete across every record.`;

  return (
    <>
      <AuditPageShell
        typeLabel={typeLabel}
        title={title}
        description={description}
      >
        <AuditHistory
          vm={auditVm}
          showRecordRef={!isEntityMode}
          entitySlug={slug}
        />
      </AuditPageShell>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(actions.logout()),
  addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
});

export const EntityAuditPage = withRouter(
  connect(
    () => ({}),
    mapDispatchToProps,
  )((props) => <AuditPage {...props} mode="entity" />),
);

export const EntityTypeAuditPage = withRouter(
  connect(
    () => ({}),
    mapDispatchToProps,
  )((props) => <AuditPage {...props} mode="entityType" />),
);

export default AuditPage;
